HRichTextComponent.$inject = ['$scope', '$element', '$filter', 'resizingManagementService'];

const stylesFormattingCommands = [
    { style: 'bold', value: 'bold' },
    { style: 'italic', value: 'italic' },
    { style: 'underline', value: 'underline' },
    { style: 'strikeThrough', value: 'line-through' }
];

function HRichTextComponent($scope, $element, $filter, resizingManagementService) {

    var self = this;
    var invisibleImagePixel = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";
    var viewModel;
    var toggleActions = {
        strikeThrough: 'underline',
        underline: 'strikeThrough',
    };
    const INSERT_ANCHOR_POSITION = {
        DEFAULT: 'DEFAULT',
        INSERT_AFTER: 'INSERT_AFTER',
    };
    const MIN_ELEMENT_SIZE = 24;
    const MAX_ELEMENT_WIDTH = 2024;
    let selectedText = '';
    var prevContentLength = 0;
    let activeColor;

    var GUARD_TEXT = '\uFEFF';
    var editor;
    var editorObserver;
    var urlPattern = /^(((http|https):\/\/\S*)|(?:(?:www\.)?[\w-]+(?:\.[\w-]+)*\.(?:ps|us|uk|com|net|live|gov|edu|org|co|app|io|ai|me|info|online|site|store){1,}((?:\/[\w-]+)*)+(?:\/[\w-]+)*(?:\/)?))$/;
    let smartFieldsRegex;

    // list selection
    self.inSmartFieldListSelectionMode = false;
    self.selectedSmartFieldsListItemIndex = 0;
    self.smartFieldslistSelectionStartRange = 0;
    self.smartFieldslistSelectionEndRange = 0;
    self.filteredSmartFields = [];

    self.currentTextFormat = {
        bold: false,
        italic: false,
        strikeThrough: false,
        underline: false,
        insertUnorderedList: false,
        insertOrderedList: false
    };
    self.isShowAddStaticField = false;
    self.staticFieldValue = '';
    self.mentionSearchText = '';



    self.smartFieldsTooltipMessage = self.smartFieldsTooltip ||
        $filter("translate")("Select the smart field you wish to use and it will be replaced with the appropriate value when the message is sent");
    const isFocusInEditor = () => {
        let selection = window.getSelection();
        let focusedElm = selection.focusNode;
        return $(focusedElm).parents().is(editor) || $(focusedElm).get(0) === editor;
    };

    const assignEventsListeners =  ()=> {
        $element.on("paste", handlePasteEvent);
        $(editor).off('mousemove').on('mousemove', handleOnMouseMove);
    };

    const cleanHTMLTags = (htmlNodeOrString, parentType) => {
        let rootNode = (typeof htmlNodeOrString === "string")
            ? $("<dummy>" + htmlNodeOrString + "</dummy>")[0]
            : htmlNodeOrString;

        if (rootNode.nodeType === 3) {
            return Utils.htmlEntities(rootNode.textContent || "");
        }

        if (rootNode.nodeType === 1) {
            let tagName = rootNode.nodeName.toLowerCase();

            // Remove MS Word and unnecessary tags
            if (["style", "script", "o:p", "w:sdt", "w:sdtPr", "w:sdtEndPr", "w:tbl", "v:shape", "v:imagedata", "st1:place", "xml", "meta", "link", "mso-list"].includes(tagName)) {
                return "";
            }

            if (tagName === "a" && (!rootNode.textContent.trim() || !rootNode.href)) {
                return "";
            }

            let children = rootNode.childNodes;
            let attributes = "";
            let allowedStyles = ["color", "background-color", "font-weight", "font-style", "text-decoration"];

            for (let i = 0; i < rootNode.attributes.length; i++) {
                let attr = rootNode.attributes[i];
                let attrName = attr.nodeName.toLowerCase();
                let attrValue = attr.textContent;

                // Remove MS Word-specific attributes
                if (attrName.startsWith("mso-") || attrName.startsWith("o:") || attrName.startsWith("v:") || attrName.startsWith("w:")) {
                    continue;
                }

                if (["class", "src", "field-code", "href_placeholder", "target", "contenteditable", "href"].includes(attrName)) {
                    attributes += ` ${attrName}="${attrValue}"`;
                }
                else if (attrName === "style") {
                    let filteredStyles = [];
                    let styles = attrValue.split(";");

                    for (let j = 0; j < styles.length; j++) {
                        let [key, value] = styles[j].split(":").map(s => s.trim().toLowerCase());

                        // Skip unwanted styles (MS Word-specific)
                        if (!allowedStyles.includes(key)) {
                            continue;
                        }

                        // Handle `font-weight` to toggle between `span` and `b`
                        if (key === "font-weight") {
                            if (["400", "300", "100", "normal"].includes(value) && ["b", "strong"].includes(tagName)) {
                                tagName = "span";
                            } else if (["600", "700", "bold"].includes(value) && !["b", "strong"].includes(tagName)) {
                                tagName = "b";
                            }
                        }

                        filteredStyles.push(`${key}: ${value}`);
                    }

                    if (filteredStyles.length > 0) {
                        attributes += ` style="${filteredStyles.join("; ")}"`;
                    }
                }
            }

            let htmlContent = "";
            for (let i = 0; i < children.length; i++) {
                let child = children[i];
                let childHTML = cleanHTMLTags(child, tagName);
                if (childHTML) {
                    htmlContent += childHTML;
                }
            }

            if (self.isTextOutput) {
                if (["span"].includes(tagName)) {
                    return `<${tagName}${attributes}>${htmlContent}</${tagName}>`;
                }
            } else {
                if (["span", "a", "div", "p", "b", "strong", "i", "strike", "u", "ol", "ul", "li", "hr", "table", "td", "tr", "tbody", "thead", "th"].includes(tagName)) {
                    return `<${tagName}${attributes}>${htmlContent}</${tagName}>`;
                }
                if (["br"].includes(tagName)) {
                    return `<${tagName}${attributes}>`;
                }
            }

            return htmlContent;
        }

        return "";
    };

    self.hasHttp = function (link) {
        return /^[\s]*http(s)?\:/.test(link);
    };

    self.applyLinkToSelection = function () {
        if (self.addLinkValue && self.hasHttp(self.addLinkValue)) {
            self.showLinkPopup = false;
            const anchorTarget = self.openAnchorsInNewTab ? '_blank' : '_self';
            wrapUrlWithAnchor(self.range, self.addLinkValue, INSERT_ANCHOR_POSITION.INSERT_AFTER, anchorTarget, selectedText);
            self.addLinkValue = "";
            selectedText = '';
        }
    };

    self.addLinkToSelection = function () {
        $element.find(".editable-area").focus();
        var selection = window.getSelection();
        selectedText = selection?.toString();
        self.range = selection.getRangeAt(0);
        self.focusedElm = selection.focusNode;
        self.linkPopupDirection = $element.offset().top < 350 ? 'down' : 'up';
        self.showLinkPopup = true;

        var elm = $(self.focusedElm);
        var originalLink = elm.attr("href");

        if (!originalLink) {
            elm = elm.parents("a");
            originalLink = elm.attr("href");
        }

        self.addLinkValue = originalLink;

        $(document).on("click.add-link", function (event) {
            if ($(event.target).parents(".add-link-button").length === 0) {
                self.addLinkValue = "";
                self.showLinkPopup = false;
                $(document).off("click.add-link");
                $scope.$digest();
            }
        });
    };

    const handlePasteEvent = (event) => {
        let clipboardData = event['originalEvent']['clipboardData'] || window['clipboardData'];

        try {
            const isContentEditable = event.target?.isContentEditable;

            let html;

            if (isContentEditable) {
                html = clipboardData.getData('text/html');

                if (!html) {
                    html = clipboardData.getData('text/plain');
                }
            } else {
                html = clipboardData.getData('text/plain');
            }
            html = cleanHTMLTags(html);

            if (isContentEditable) {
                document.execCommand('insertHTML', false, html);
            } else {
                document.execCommand('insertText', false, html);
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        } catch (e) {
            setTimeout(function () {
                let html = cleanHTMLTags($element.find(".editable-area").html());
                $element.find(".editable-area").html(html);
            }, 100);
        }
    };

    const handleOnMouseMove = (e) => {
        if (resizingManagementService.isCursorInElementCorner(e)) {
            $(resizingManagementService.currentElement).css('cursor', 'se-resize');
        } else {
            $(resizingManagementService.currentElement).css('cursor', 'auto');
        }
        if (resizingManagementService.currentElement && resizingManagementService.resizing) {

            let elm = resizingManagementService.currentElement;
            let height = e.pageY - resizingManagementService.offset(elm).top;
            let width = e.pageX - resizingManagementService.offset(elm).left;
            height = height < MIN_ELEMENT_SIZE ? MIN_ELEMENT_SIZE : height;
            width = width < MIN_ELEMENT_SIZE ? MIN_ELEMENT_SIZE : width;
            if (width > MAX_ELEMENT_WIDTH) {
                width = MAX_ELEMENT_WIDTH;
            }

            $(resizingManagementService.currentElement).css('width', (width) + 'px');
            $(resizingManagementService.currentElement).css('height', (height) + 'px');
        }
        syncViewWithModel();

    };


    self.storeRange = function () {
        const selection = window.getSelection();
        self.range = selection.getRangeAt(0);
        self.focusedElm = selection.focusNode;
    };

    self.onEmojiSelected = function (emojiCode) {
        if(emojiCode){
            restoreSelectedRange();
            self.execAddEmoji(null, emojiCode);
        }
    };

    self.onGifClicked = function (data) {
        if (self.appendToHRichText) {
            self.addGifSelected(data);
        } else {
            self.onGifSelected(data);
        }
    };

    self.onOpenGifDialog = function () {
        var selection = window.getSelection();
        self.range = selection.getRangeAt(0);
        self.focusedElm = selection.focusNode;
    };

    var focusInEditor = function () {
        setDocumentSelectToEndOfNode(editor);
        editor.focus();
    };

    const setDocumentSelectToEndOfNode = (node) => {
        if (!node) {
            return;
        }

        const selection = window.getSelection();
        const range = document.createRange();

        if (node.nodeType === Node.TEXT_NODE || !node.lastChild) {
            selection.removeAllRanges();
            range.selectNodeContents(node);
            range.collapse(false);
            selection.addRange(range);
            self.updateSelectedActions();
        } else {
            let lastNode = node.lastChild;
            while (lastNode.lastChild && lastNode.nodeType !== Node.TEXT_NODE) {
                lastNode = lastNode.lastChild;
            }
            setDocumentSelectToEndOfNode(lastNode);
        }
    };

    self.execAddEmoji = function ($event, emojiCode) {
        stopUserEvent($event)
        if (!isFocusInEditor()) {
            focusInEditor();
        }

        setTimeout(function () {
            document.execCommand('insertHTML', false, emojiCode);
            setTimeout(function () {
                $element.find(".h-dynamic-field").attr("contenteditable", "false");
                syncViewWithModel();
                $scope.$apply();
            }, 1);
        }, 1);
    };

    self.execCmd = ($event, cmd, value) => {
        stopUserEvent($event);
        if (!isFocusInEditor()) {
            focusInEditor();
        }

        setTimeout(() => {
            let executed = false;

            if (toggleActions[cmd] && document.queryCommandState(toggleActions[cmd])) {
                document.execCommand(toggleActions[cmd], false, value);
                if (self.currentTextFormat) {
                    self.currentTextFormat[toggleActions[cmd]] = false;
                }
                executed = true;
            }

            if (!executed) {
                document.execCommand(cmd, false, value);
            }

            self.toggleAction(cmd);
            moveCursorForList(cmd);

            setTimeout(() => {
                $element.find(".h-dynamic-field").attr("contenteditable", "false");
                syncViewWithModel();
                $scope.$applyAsync();
            }, 5);
        }, 2);
    };

    self.addGifSelected = async function (data) {
        if (!isFocusInEditor()) {
            focusInEditor();
        }

        let res = await GifsAPI.getGifById(data.id);
        let gifData = res.data;
        let range = window.getSelection().getRangeAt(0);
        let rangeStartOffset = range.startOffset;
        let html = "<span contenteditable='false' style='display: inline-flex; flex-direction: column'>" +
            "<img alt='" + gifData.title + "' src='" + gifData.images.fixed_width_downsampled.url + "' draggable = 'false'>" +
            "<span  style = 'font-size: 12px; margin-top: 1rem'>" +
            "<img alt='giphy' src='//cdn.harridev.com/658760e4-38f1-4383-9a58-7e2fa89b5fbe/images/giphy.svg' draggable = 'false' style='width: 20px;" +
            "  height: 20px;'> " + $filter("translate")("Posted using") + " Giphy";

        if (gifData.user) {
            html += " | GIF " + $filter("translate")("by") +
                " <a target='_blank' href='" + gifData.user.profile_url + "'>" + gifData.user.display_name + "</a>";
        }

        html += "</span></span>";
        document.execCommand('insertHTML', false, '<img src="' + invisibleImagePixel + '">');
        setTimeout(function () {
            $element
                .find("[src='" + invisibleImagePixel + "']")
                .replaceWith(html);

            try {
                range.setStart(range.commonAncestorContainer, rangeStartOffset);
                range.setEnd(range.commonAncestorContainer, rangeStartOffset);
                getSelection().addRange(range);
            } catch (e) {
                console.error(e)
            }
            syncViewWithModel();
        }, 1);
    };

    self.onImageSelected = function (files) {
        if (files && files.length > 0) {
            let file = files[0];
            if (!file.type.startsWith('image/')) {
                hConfirm({
                    title: $filter("translate")("Add an image"),
                    text: $filter("translate")('Please select an image file (JPEG, JPG, PNG).'),
                    confirmButton: $filter("translate")("Ok"),
                    cancelButtonClass: 'hidden',
                });
                return;
            }
            self.isUploading = true;
            self.onUploadImage({files: file})
                .then(url => {
                    self.addImageSelected(url);
                    self.isUploading = false;
                })
                .catch(err => {
                    self.isUploading = false;
                    console.error('Error handling image upload:', err);
                });
        }
    };
    self.addImageSelected = function (url) {
        let withOutAccessKeyUrl = url.split('?')[0];
        self.execCmd(event, "insertHTML", `<img style='max-width:100%; object-fit: contain;' draggable='false' src='${withOutAccessKeyUrl}'/>`);
        editor = $element.find('.editable-area').get(0);
        resizingManagementService.assignResizingHandlers(editor);
    };


    self.addSmartField = function ($event, field) {
        stopUserEvent($event)
        if (!isFocusInEditor()) {
            focusInEditor();
        }
        const activeStyles = {};

        for (const { style } of stylesFormattingCommands) {
            activeStyles[style] = document.queryCommandState(style);
        }

        document.execCommand('insertHTML', false, '<img src="' + invisibleImagePixel + '">');

        setTimeout(function () {
            var range = window.getSelection().getRangeAt(0);
            var rangeStartOffset = range.startOffset;
            var fieldName = field['name'];
            switch (field.type) {
                case 'BUTTON':
                    $element
                        .find("[src='" + invisibleImagePixel + "']")
                        .replaceWith('<span field-code="' + field['code'] + '" class="h-dynamic-btn" contenteditable="false">' + fieldName + '</span>');
                    break;
                case 'CUSTOM_AREA':
                    $element
                        .find("[src='" + invisibleImagePixel + "']")
                        .replaceWith('<span field-code="' + field['code'] + '" class="h-dynamic-custom-area" contenteditable="false">' + fieldName + '</span>');
                    break;
                case 'LINK':
                    $element
                        .find("[src='" + invisibleImagePixel + "']")
                        .replaceWith('<a field-code="' + field['code'] + '" href_placeholder="{{' + field['code'] + '}}" target="_blank">' + fieldName + '</a>');
                    break;
                default:
                    $element
                        .find("[src='" + invisibleImagePixel + "']")
                        .replaceWith('<span field-code="' + field['code'] + '" class="h-dynamic-field" contenteditable="false">' + fieldName + '</span>');

                    var mentionSpan = $element.find("[field-code='" + field['code'] + "']");
                    addSpaceAfterElement(mentionSpan);
                    for (const { style } of stylesFormattingCommands) {
                        if (activeStyles[style]) {
                            document.execCommand(style, false, 'true');
                        }
                    }
            }

            try {
                range.setStart(range.commonAncestorContainer, rangeStartOffset);
                range.setEnd(range.commonAncestorContainer, rangeStartOffset);
                getSelection().addRange(range);
            } catch (e) {

            }

            syncViewWithModel();
        }, 1);
    };

    var addSpaceAfterElement = function (ele) {
        const spaceNode = document.createTextNode('\u00A0');
        ele.after(spaceNode);

        const range = document.createRange();
        const selection = window.getSelection();

        range.setStart(spaceNode, 1);
        range.setEnd(spaceNode, 1);

        selection.removeAllRanges();
        selection.addRange(range);
    }

    self.$onInit = function () {
        editor = $element.find('.editable-area').get(0);
        self.name = self.name || self.hName;
        if (self.smartFields) {
            self.filteredSmartFields = [...self.smartFields];
        }

        self.openSmartFieldMark = self.openSmartFieldMark || '{';
        self.closeSmartFieldMark = self.closeSmartFieldMark || '}';
        smartFieldsRegex = new RegExp(
            'xx([^uu]*)uu'.replace(/xx/g, '\\'+self.openSmartFieldMark)
                .replace(/uu/g, '\\'+self.closeSmartFieldMark), "g");
        editor.addEventListener('blur', function(event) {
            handleURLDetection();
            fireInputBlur();
        });
        editor.addEventListener('input', function(event) {
            detectMention();
        });
        resizingManagementService.assignResizingHandlers(editor);
        if (self.autoLinkDetect) {
            assignOnChange();
        }
    };

    var fireInputBlur = function () {
        $element.find('[name="' + self.name + '"]').change();
    };

    self.$onChanges = function (changesObj) {
        if (changesObj.smartFields && !changesObj.smartFields.isFirstChange()) {
            self.filteredSmartFields  = [...self.smartFields];
        }
        if (changesObj.activeTextFormat && !changesObj.activeTextFormat.isFirstChange()) {
            self.currentTextFormat = {...self.activeTextFormat};
        }
        if (changesObj.smartFieldsTooltip) {
            if (self.smartFieldsTooltip) {
                self.smartFieldsTooltipMessage = self.smartFieldsTooltip;
            }
        }
    };

    self.$doCheck = function () {
        syncModelWithView();
    };

    self.$onDestroy = function () {
        cancelListSelectionMode();
    };

    function contentChanged(mutations) {
        if (self.autoLinkDetect) {
            checkIfLinkChanged(mutations);
        }
    }

    function checkIfLinkChanged(mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeName === 'A' && node.hasAttribute('target') && !node.href) {
                        var anchorText = node.innerText;
                        anchorText = anchorText.startsWith('http') ? anchorText : 'https://' + anchorText;
                        node.href = anchorText.trim();
                    }
                });
            } else if (mutation.type === 'characterData') {
                var anchor = mutation.target.parentElement;
                if (anchor && anchor.nodeName === 'A' && anchor.hasAttribute('target') && !anchor.href) {
                    var anchorText = anchor.innerText;
                    anchorText = anchorText.startsWith('http') ? anchorText : 'https://' + anchorText;
                    anchor.href = anchorText.trim();
                }
            }
        });
    }

    function assignOnChange() {
        let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        editorObserver = new MutationObserver(contentChanged);
        observeEditor();
    }

    function observeEditor() {
        editorObserver && editorObserver.observe(editor, {childList: true, subtree: true, characterData: true});
    }

    function wrapUrlWithAnchor(range, word, insertAction = INSERT_ANCHOR_POSITION.DEFAULT, anchorTarget = '_blank', anchorContent) {
        const selection = window.getSelection();
        anchorContent = anchorContent || word;

        if (insertAction === INSERT_ANCHOR_POSITION.DEFAULT) {
            const startOffset = range.startOffset - anchorContent.length;
            const endOffset = range.startOffset;
            range.setStart(range.startContainer, startOffset);
            range.setEnd(range.startContainer, endOffset);
        }

        range.deleteContents();

        const anchorTag = document.createElement('a');
        anchorTag.href = word;
        anchorTag.target = anchorTarget;
        anchorTag.rel = 'nofollow';
        anchorTag.textContent = anchorContent;

        range.insertNode(anchorTag);

        range.setStartAfter(anchorTag);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
        syncViewWithModel();
    }

    function handleURLDetection() {
        if (self.autoLinkDetect) {
            const selection = window.getSelection();
            const range = selection.getRangeAt(0);
            const text = range.startContainer.textContent;
            const wordEndIndex = range.startOffset;

            const previousSpaceIndex = text.lastIndexOf(' ', wordEndIndex - 2);
            const wordStartIndex = previousSpaceIndex === -1 ? 0 : previousSpaceIndex + 1;
            const word = text.substring(wordStartIndex, wordEndIndex);

            const isURL = urlPattern.test(word.trim());
            if (isURL) {
                wrapUrlWithAnchor(range, word);
            }
        }
    }

    var triggerChange = function (value) {
        $timeout(function () {
            $element.find("input[type='text']").change();
            self.ngChange({value: self.ngModel});
        }, 100);
    };

    const syncViewWithModel = () => {
        if (self.isDisabled) {
            return;
        }

        const editableArea = $element.find(".editable-area")[0];

        if (!editableArea) {
            return;
        }

        let viewHTML = editableArea.cloneNode(true);

        const elementsToReplace = viewHTML.querySelectorAll(".h-dynamic-field, .h-dynamic-btn, .h-dynamic-custom-area");
        elementsToReplace.forEach(element => {
            const fieldCode = element.getAttribute("field-code");
            element.replaceWith(self.openSmartFieldMark + fieldCode + self.closeSmartFieldMark);
        });

        if (self.isTextOutput) {
            self.ngModel = self.singleLine ? viewHTML.textContent : htmlToTextWithNewLines(viewHTML);
        } else {
            self.ngModel = viewHTML.innerHTML;
        }

        triggerChange();
        viewModel = self.ngModel;
    };

    const syncModelWithView = () => {
        let model = self.ngModel || "";
        if (model === viewModel){
            return;
        }

        const editableArea = $element.find(".editable-area");
        editableArea.css("display", "none");

        viewModel = model;

        if (self.smartFields?.length) {
            model = model.replace(smartFieldsRegex, (match, possibleSmartFieldCode) => {
                let smartField = self.smartFields.find(item => item.code === possibleSmartFieldCode);

                if (!smartField) {
                    return match;
                }

                const fieldClass = {
                    "TEXT": "h-dynamic-field",
                    "STATIC_LINK": "h-dynamic-field",
                    "BUTTON": "h-dynamic-btn",
                    "CUSTOM_AREA": "h-dynamic-custom-area"
                }[smartField.type];

                return fieldClass
                    ? `<span class="${fieldClass}" field-code="${smartField.code}" contenteditable="false">${smartField.name}</span>`
                    : match;
            });
        }

        if (self.isTextOutput && !self.singleLine) {
            model = model.replaceAll("\n", "<br>");
        }


        if (editableArea.html() !== model) {
            editableArea.html(model);
        }
        editableArea.css("display", "");
    };

    let htmlToTextWithNewLines = (node) => {
        let text = '';
        if (node.nodeType === Node.TEXT_NODE) {
            text += node.textContent;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            switch (node.nodeName.toLowerCase()) {
                case 'div':
                case 'p':
                case 'li':
                    for (const child of node.childNodes) {
                        text += htmlToTextWithNewLines(child);
                    }
                    text += '\n';
                    break;
                case 'br':
                    text += '\n';
                    break;
                default:
                    for (const child of node.childNodes) {
                        text += htmlToTextWithNewLines(child);
                    }
                    break;
            }
        }
        return text;
    }

    self.onSmartFieldsListItemClicked = function (index) {
        setTimeout(function () {
            self.selectedSmartFieldsListItemIndex = index;
            $(self.focusedElm).parent().focus();
            getSelection().removeAllRanges();
            self.range.setStart(self.range.commonAncestorContainer, self.smartFieldslistSelectionStartRange - self.mentionSearchText.length);
            self.range.setEnd(self.range.commonAncestorContainer, self.smartFieldslistSelectionEndRange);
            self.range.deleteContents();
            getSelection().addRange(self.range);
            let field = {...self.filteredSmartFields[index]};
            if (self.addSmartFieldCharacterToView) {
                field.name = '@' + field.name;
            }
            self.addSmartField(null, field);
            cancelListSelectionMode();
            $scope.$digest();
        }, 10);
    };

    var activateListSelectionMode = function (searchText) {
        self.inSmartFieldListSelectionMode = false;
        self.filteredSmartFields = self.smartFields.filter(function (item) {
            return item.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        });

        self.selectedSmartFieldsListItemIndex = 0;
        if (self.smartFields.length) {
            self.inSmartFieldListSelectionMode = true;
        }
        setTimeout(function () {
            var selection = window.getSelection();
            self.range = selection.getRangeAt(0);
            self.smartFieldslistSelectionStartRange = self.range.startOffset - 1;
            self.smartFieldslistSelectionEndRange = self.range.endOffset;
            $(document).on("click.smart-fields-list-selection-dropdown", function (event) {
                if ($(event.target).parents(".smart-fields-items-list").length === 0) {
                    cancelListSelectionMode();
                    $scope.$digest();
                }
            });
        }, 1);
    };

    var cancelListSelectionMode = function () {
        self.filteredSmartFields = self.smartFields && [...self.smartFields];
        self.inSmartFieldListSelectionMode = false;
        self.selectedSmartFieldsListItemIndex = 0;
        self.mentionSearchText = '';
        $(document).off("click.smart-fields-list-selection-dropdown");
    };

    var stopUserEvent = function ($event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $event.stopImmediatePropagation();
        }
    };

    var onListSelectionModeKeyDown = function ($event) {
        if ($event.keyCode === 37 || $event.keyCode === 38) { // UP
            stopUserEvent($event);
            self.selectedSmartFieldsListItemIndex--;
            if (self.selectedSmartFieldsListItemIndex === -1) {
                self.selectedSmartFieldsListItemIndex = self.filteredSmartFields.length - 1;
            }
        } else if ($event.keyCode === 39 || $event.keyCode === 40) { // DOWN
            stopUserEvent($event);
            self.selectedSmartFieldsListItemIndex++;
            if (self.selectedSmartFieldsListItemIndex === self.filteredSmartFields.length) {
                self.selectedSmartFieldsListItemIndex = 0;
            }
        } else if ($event.keyCode === 27) { //ESC
            stopUserEvent($event);
            cancelListSelectionMode();

        } else if ($event.keyCode === 13 || $event.keyCode === 9) { //ENTER or TAB
            if (self.filteredSmartFields.length) {
                stopUserEvent($event);
                self.onSmartFieldsListItemClicked(self.selectedSmartFieldsListItemIndex);
            } else {
                cancelListSelectionMode();
            }
        }
    };

    self.onKeyDown = function ($event) {
        if ($event.keyCode === 13) {
            handleURLDetection();
            if (self.singleLine) {
                stopUserEvent($event);
            }
        }

        if (event.keyCode === 32) {
            handleURLDetection();
        }
        if (self.inSmartFieldListSelectionMode) {
            onListSelectionModeKeyDown($event);
        }
        if (!self.inSmartFieldListSelectionMode && self.onKeyDownEvent) {
            self.onKeyDownEvent($event);
        }
    };

    function detectMention() {
        var currentAndPreviousWord = getCurrentAndPreviousWord();
        var currentWord = currentAndPreviousWord.currentWord.trim();
        var previousWord = currentAndPreviousWord.previousWord.trim();

        if (self.showSmartFieldsListSelection && currentWord.startsWith('@') && currentWord.length >= 3) {
            self.mentionSearchText = currentWord.substring(1);
            self.listSelectionDirection = $element.offset().top < 350 ? 'down' : 'up';
            activateListSelectionMode(self.mentionSearchText);

        } else if (self.showSmartFieldsListSelection && previousWord.startsWith('@') && (previousWord.length + currentWord.length) >= 3) {
            self.mentionSearchText = previousWord.substring(1) + ' ' + currentWord;
            self.listSelectionDirection = $element.offset().top < 350 ? 'down' : 'up';
            activateListSelectionMode(self.mentionSearchText);
        } else if (self.inSmartFieldListSelectionMode) {
            cancelListSelectionMode();
        }
    }

    function getCurrentAndPreviousWord() {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const startOffset = range.startOffset;
        var node = window.getSelection().focusNode;
        const content = node.textContent;
        const words = content.split(' ');

        var currentWord = '';
        var previousWord = '';
        var currentOffset = 0;
        for (var i = 0; i < words.length; i++) {
            currentOffset += words[i].length + 1;
            if (currentOffset > startOffset) {
                currentWord = words[i];
                previousWord = i > 0 ? words[i - 1] : '';
                break;
            }
        }
        return {currentWord: currentWord, previousWord: previousWord};
    }

    const restoreSelectedRange = () => {
        $element.find(self.focusedElm).parent().focus();
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(self.range);
    };

    const setActiveColor = (color) => {
        setTimeout(() => {
            document.execCommand('styleWithCSS', false, true);
            document.execCommand('foreColor', false, color);
            syncViewWithModel();
        }, 1);
    };

    self.changeColor = (color) => {
        activeColor = color;
        restoreSelectedRange();
        if (!isFocusInEditor()) {
            focusInEditor();
        }
        setActiveColor(color);
    };

    self.handleChange = function ($event) {
        syncViewWithModel();
        if(self.onKeyUpEvent){
            self.onKeyUpEvent($event);
        }
        resetWhenEmpty();
        self.updateSelectedActions();
    };

    var resetWhenEmpty = function () {
        var contentText = self.ngModel;
        contentText = contentText === '<br>' ? '' : contentText;
        if (prevContentLength && prevContentLength !== contentText.length && !contentText) {
            var guardNode = document.createTextNode(GUARD_TEXT);
            editor.appendChild(guardNode);
            document.execCommand('selectAll');
            document.execCommand('removeFormat');
            editor.removeChild(guardNode);
            setDocumentSelectToEndOfNode(editor)
        }
        prevContentLength = contentText.length;
    }

    self.$postLink = function () {
        syncModelWithView();
        assignEventsListeners();
    };


    self.updateSelectedActions = function () {
        if (self.activeTextFormat) {
            for (var currentTextFormatKey in self.currentTextFormat) {
                self.currentTextFormat[currentTextFormatKey] = document.queryCommandState(currentTextFormatKey);
            }
        }
    }

    self.onContentEditableAreaClick = () => {
        self.updateSelectedActions();

        if (activeColor) {
            const selection = window.getSelection();

            if (selection.isCollapsed) {
                setActiveColor(activeColor);
            }
        }
    };

    self.toggleAction = function (cmd) {
        if (self.activeTextFormat) {
            self.currentTextFormat[cmd] = !self.currentTextFormat[cmd];
        }
    }

    let moveCursorForList = (cmd) => {
        if (['insertUnorderedList', 'insertOrderedList'].indexOf(cmd) > -1 && document.queryCommandState(cmd)) {
            let node = window.getSelection().focusNode.parentNode;
            while (node && node.tagName !== 'LI') {
                if (node.isContentEditable) {
                    break;
                }
                node = node.parentNode;
            }
            setDocumentSelectToEndOfNode(node);
        }
    }

    self.insertStaticField = function ($event, field) {
        stopUserEvent($event);
        if (!isFocusInEditor()) {
            focusInEditor();
        }

        setTimeout(function () {
            var range = window.getSelection().getRangeAt(0);
            var fieldName = field['name'];
            var node = document.createTextNode(fieldName);
            range.insertNode(node);
            try {
                range.setStart(node, fieldName.length);
                range.setEnd(node, fieldName.length);
                getSelection().removeAllRanges();
                getSelection().addRange(range);
            } catch (e) {
                console.log(e)
            }

            syncViewWithModel();
        }, 1);
    };

    self.showStaticFieldDetails = function ($event, field) {
        if (field) {
            field.isShowEditStaticField = true;
            self.staticFieldValue = field.name;
        } else {
            self.isShowAddStaticField = true;
            self.staticFieldValue = '';
        }
    };

    self.hideStaticFieldDetails = function ($event, field) {
        if (field) {
            field.isShowEditStaticField = false;
        } else {
            self.isShowAddStaticField = false;
        }
        self.staticFieldValue = '';
    };

    self.saveStaticField = function (field) {
        if (field) {
            field.name = self.staticFieldValue;
            field.isSaving = true;
            field.isShowEditStaticField = false;
            self.onUpdateStaticField(field);
        } else {
            self.isShowAddStaticField = false;
            self.onAddStaticField(self.staticFieldValue);
        }
    };

    self.deleteStaticField = function ($event, fieldIndex) {
        self.onDeleteStaticField(self.staticFields[fieldIndex]);
        self.staticFields[fieldIndex].isSaving = true;
    };

    self.$onDestroy = function () {
        cancelListSelectionMode();
        $element.off("paste");
        $(editor).off('mousemove');
        $(document).off("click.add-link");
        $(document).off("click.smart-fields-list-selection-dropdown");
        if (editorObserver) {
            editorObserver.disconnect();
        }
    };
}

angular
    .module('components')
    .component("hRichText", {
        bindings: {
            ngModel: "=",
            ngChange: '&',
            name: '@',
            hName: '@',
            isDisabled: "<",
            placeholder: "<",
            onKeyDownEvent: "&onKeyDownEvent",
            onKeyUpEvent: "&onKeyUpEvent",
            hideIndents: "<",
            editableAreaLines: '<',
            autoResize: '<',
            hideAnchors: "<",
            customFontColor: '<',
            openAnchorsInNewTab: '<',
            addSmartFieldCharacterToView: "<",
            showSmartFieldsListSelection: "<",
            showUserAvatarInListSelection: "<",
            showItemDescriptionInListSelection: "<",
            hideSmartFieldsToolbar: "<",
            showEmojisSelector: "<",
            smartFields: "<",
            smartFieldsTooltip: "<",
            openSmartFieldMark: "<",
            closeSmartFieldMark: "<",
            singleLine: "<",
            isTextOutput: "<",
            hideActions: '<',
            autoLinkDetect: "<",
            activeTextFormat: "<",
            staticFields: "<",
            enableGifs: "<",
            giphySelectorDirection: "<?",
            brandId: "<?",
            appendToHRichText: "<?",
            onUploadImage: '&?',
            enableImage: "<?",
            onGifSelected: "&onGifSelected",
            onAddStaticField: "&onAddStaticField",
            onUpdateStaticField: "&onUpdateStaticField",
            onDeleteStaticField: "&onDeleteStaticField"
        },
        controller: HRichTextComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-rich-text/h-rich-text.component.ng.html'
    });
